
import React, { useState, useEffect } from "react";
import "../styles/contact.css";

function Contact() {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  useEffect(() => {
    const onLangChanged = () => {
      setLang(localStorage.getItem("lang") || "fr");
    };
    window.addEventListener("langChanged", onLangChanged);
    return () => window.removeEventListener("langChanged", onLangChanged);
  }, []);

  return (
    <div className="contact-page">

      <div className="contact-grid">

        {/* LEFT SIDE - FORM */}
        <div className="contact-form-box">
          <h2>
            {lang === "fr"
              ? "Formulaire de contact"
              : "Taratasy fifandraisana"}
          </h2>

          <div className="form-row">
            <input type="text" placeholder={lang === "fr" ? "Prénom *" : "Anarana *"} />
            <input type="text" placeholder={lang === "fr" ? "Nom *" : "Fanampiny *"} />
          </div>

          <div className="form-row">
            <input type="email" placeholder="Email *" />
            <input type="text" placeholder={lang === "fr" ? "Téléphone" : "Telefaonina"} />
          </div>

          <select className="full-width">
            <option>
              {lang === "fr" ? "Sujet *" : "Lohahevitra *"}
            </option>
            <option>
              {lang === "fr" ? "Commande" : "Baiko"}
            </option>
            <option>
              {lang === "fr" ? "Livraison" : "Fandefasana"}
            </option>
            <option>
              {lang === "fr" ? "Produit" : "Entana"}
            </option>
          </select>

          <textarea
            rows="5"
            placeholder={
              lang === "fr"
                ? "Message * (minimum 10 caractères)"
                : "Hafatra * (10 litera farafahakeliny)"
            }
          ></textarea>

          <button className="send-btn">
            {lang === "fr" ? "Envoyer le message" : "Alefa ny hafatra"}
          </button>
        </div>

        {/* RIGHT SIDE - INFOS */}
        <div className="contact-info-box">

          <h3>
            {lang === "fr"
              ? "Informations de contact"
              : "Momba ny fifandraisana"}
          </h3>

          <div className="info-item">
            <span>📍</span>
            <div>
              <strong>{lang === "fr" ? "Adresse" : "Adiresy"}</strong>
              <p>Antananarivo, Madagascar</p>
            </div>
          </div>

          <div className="info-item">
            <span>📞</span>
            <div>
              <strong>{lang === "fr" ? "Téléphone" : "Telefaonina"}</strong>
              <p>+261 34 12 345 67</p>
            </div>
          </div>

          <div className="info-item">
            <span>📧</span>
            <div>
              <strong>Email</strong>
              <p>contact@tantsaha-mada.com</p>
            </div>
          </div>

          <div className="info-item">
            <span>⏰</span>
            <div>
              <strong>{lang === "fr" ? "Horaires" : "Ora fiasana"}</strong>
              <p>Lun - Ven : 8h - 17h</p>
            </div>
          </div>

        </div>

      </div>

      {/* FAQ */}
      <div className="faq-section">
        <h3>FAQ</h3>

        <details>
          <summary>
            {lang === "fr"
              ? "Comment suivre ma commande ?"
              : "Ahoana ny fanarahana ny baiko?"}
          </summary>
          <p>
            {lang === "fr"
              ? "Vous pouvez suivre votre commande depuis votre compte."
              : "Azonao arahina ao amin'ny kaontinao ny baiko."}
          </p>
        </details>

        <details>
          <summary>
            {lang === "fr"
              ? "Les produits sont-ils locaux ?"
              : "Vokatra avy eto an-toerana ve?"}
          </summary>
          <p>
            {lang === "fr"
              ? "Oui, tous nos produits proviennent des tantsaha locaux."
              : "Eny, avy amin'ny tantsaha eto Madagasikara ny vokatra rehetra."}
          </p>
        </details>

      </div>

    </div>
  );
}

export default Contact;
